'use strict';

const Vue = require('../../node_modules/vue/dist/vue.min.js');
const Vuex = require('vuex');
const App = require('./vue/App.vue');
const { initStore } = require('./vue/store');
const { onVisibleVue } = require('../../services/client/visibility');

module.exports = (el) => {
  Vue.use(Vuex);
  Vue.directive('on-visible', onVisibleVue);

  new Vue({
    el: '.search-remix',
    delimiters: ['${', '}'],
    store: initStore(el.dataset),
    components: {
      app: App,
    },
  });
};
